import { createRef, createContext } from 'react';

import { ModalContext } from './base-modal.types';

export const BaseModalContext = createContext<ModalContext>({
	contentRef: createRef<HTMLElement>(),
	close: (): void => undefined,
	isOpen: false,
});
